import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';
import { CarouselsService } from 'src/app/services/carousels.service';
import { CarouselsModalComponent } from './carousels-modal/carousels-modal.component';
import { FileStorageService } from 'src/app/services/file-storage.service';



@Component({
  selector: 'app-carousels',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './carousels.component.html',
  styleUrls: ['./carousels.component.css']
})
export class CarouselsComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private CarouselsService: CarouselsService,
      private fileStorage: FileStorageService,
      private changeDetectorRef: ChangeDetectorRef
  ) {
   
    
  } 

  
  CarouselsList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getCarousels();
  }

  getCarousels(){
    this.CarouselsService.getCarousels().subscribe({
      next: (res: any) => {
        this.CarouselsList = res.map((item: any) => {
          return {
            ...item,
            file: item.fileId ? this.fileStorage.getFileUrl(item.fileId) : null
          };
        });
        
        this.filteredData = this.CarouselsList;
        this.changeDetectorRef.detectChanges();
      }});
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(CarouselsModalComponent, {
      data: { item, mode, title }
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getCarousels();
        }
      }
    });
  }

}
